import {getAlphaLabelFromIndex} from 'common/util';

import {SankeyEdge} from './sankey-edge';
import {SankeyPart} from './sankey-part';
import {SerializedSankeyNode} from './serialized';
import {Alignment, SankeyAnchorType, SankeyNodeType} from './types';

export class SankeyNode extends SankeyPart {
  public alignment: number;
  public edges: SankeyEdge[];
  public incomingEdges: SankeyEdge[];
  public index: number;
  public section: number;
  public conversionRateChange: number;
  public isCustomEvent: boolean;

  constructor(serializedSankeyNode: SerializedSankeyNode, alignment?: number, section?: number) {
    super(serializedSankeyNode);
    this.edges = (serializedSankeyNode.edges || []).map((edge) => new SankeyEdge(edge));
    this.incomingEdges = [];
    this.alignment = alignment;
    this.section = section;
    this.conversionRateChange = serializedSankeyNode.conversionRateChange;
    this.isCustomEvent = serializedSankeyNode.isCustomEvent;
  }

  public addIncomingEdge(edge): void {
    this.incomingEdges.push(edge);
  }

  // edges are sorted by how high they appear in the flow, this property
  // is maintained by sorting each of the nodes in each step
  public sortEdges(): void {
    this.edges = this.edges.sort((a, b) => a.toNode.index - b.toNode.index);
  }

  public inAnchorStep(): boolean {
    return this.type === SankeyNodeType.Anchor && this.anchorType === SankeyAnchorType.Normal;
  }

  public isAnchorNode(): boolean {
    return this.type === SankeyNodeType.Anchor && this.anchorType !== SankeyAnchorType.Normal;
  }

  public hasLift(): boolean {
    return !this.inAnchorStep() && !this.isAnchorNode() && !this.isDropOff && this.conversionRateChange !== 0;
  }

  public getAnchorIndex(): number {
    const letterIndex =
      this.alignment === Alignment.RIGHT && this.anchorType !== SankeyAnchorType.Normal
        ? this.section - 1
        : this.section;
    return Number.isInteger(letterIndex) ? letterIndex : null;
  }

  public getLetterLabel(): string {
    const letterIndex = this.getAnchorIndex();
    return this.type === SankeyNodeType.Anchor && letterIndex !== null ? getAlphaLabelFromIndex(letterIndex) : null;
  }
}
